import { Navigate, createFileRoute } from '@tanstack/react-router'
import { useActiveWorkspace } from '@/features/account/workspace-switch'
import { WorkspaceBootLoader } from '@/features/account/components/workspace-boot-loader'

export const Route = createFileRoute('/_app/')({
  component: AppIndexRedirect,
})

function AppIndexRedirect() {
  const { workspaces, isLoading } = useActiveWorkspace()

  if (isLoading) {
    return <WorkspaceBootLoader message="Preparing your dashboard" />
  }

  // The workspace is the only top-level/billing entity. A member lands on the
  // dashboard; anyone without a workspace creates one first.
  if (workspaces.length === 0) {
    return <Navigate to="/create-workspace" replace />
  }

  return <Navigate to="/dashboard" replace />
}
